<template>
  <div class="wrap-insert-box" v-if="item" v-on:click="activeBox">
    <div class="insert-bg" v-bind:class="{ active:active }"></div>
    <div class="insert-box" v-bind:class="{ active:active }">
      <form class="content" v-on:submit.prevent="submitForm">
        <a class="close-box" v-on:click="activeBox">
          <i class="fas fa-times"></i>
        </a>
        <div class="box">
          <div class="poster">
            <div class="avatar">
              <img v-if="user && user['feature_image_path']" :src="user.feature_image_path" />
              <img v-else src="/static/images/avatar.jpg" />
            </div>
          </div>
          <textarea
            class="form-control"
            id="description-item"
            required
            :placeholder="'Enter description about product that you want to sell or buy'|translate"
            v-model="item.description"
          ></textarea>
        </div>
        <div class="tools">
          <input
            type="file"
            id="file-upload"
            multiple
            ref="file"
            v-on:change="handleFileUpload()"
            style="display:none"
          />
          <div class="inner-tools">
            <a :disabled="uploadingPhoto" v-on:click="triggerFile">
              <i class="fas fa-images"></i>
              {{'Photos'|translate}}
            </a>

            <div class="type">
              <p class="inline" v-for="_item in list_types" :value="_item.id" :key="_item.id">
                <input
                  type="radio"
                  :value="_item.id"
                  :id="random+ _item.id "
                  v-model="item.type_id"
                />
                <label :for="random+ _item.id ">
                  <span></span>
                  {{_item.name}}
                </label>
                &nbsp;
              </p>
            </div>
          </div>
        </div>

        <div class="more pd10">
          <div class="gallery">
            <div v-if="editPhotos.length >0">
              <div v-for="(photo) in editPhotos" :key="photo.id" class="gallery-item">
                <img :src="photo.url_thumb" class="thumb" />
                <a v-on:click="removePhoto(photo)" class="btn btn-danger">
                  <i class="fas fa-times"></i>
                  {{'Remove'|translate}}
                </a>
              </div>
            </div>
          </div>
          <div class="row clear">
            <div class="col-md-4 col-xs-6 col-sm-6">
              <div class="form-group">
                <label>{{'Product Name'|translate}}</label>
                <select class="form-control" v-model="item.product_id" required>
                  <option value>{{'All products'|translate}}...</option>
                  <option
                    v-for="item in allProducts"
                    :value="item.id"
                    :key="item.id"
                  >{{ item.name }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-4 col-xs-6 col-sm-6">
              <div class="form-group">
                <label>{{'Số lượng (kg)'|translate}}</label>
                <input
                  type="number"
                  class="form-control"
                  min="1"
                  required
                  v-model="item.quantity"
                  placeholder
                />
              </div>
            </div>
            <div class="col-md-4 col-xs-6 col-sm-6">
              <div class="form-group">
                <label>{{'Đơn giá (VND)'|translate}}</label>
                <input
                  type="number"
                  class="form-control"
                  min="100"
                  required
                  v-model="item.unit_price"
                  placeholder
                />
              </div>
            </div>
            <div class="col-md-12 col-xs-6 col-sm-6">
              <div class="form-group">
                <label>{{'Payment methods'|translate}}</label>
                <select class="form-control" v-model="item.payment_method" required>
                  <option value>{{'Select'|translate}}...</option>
                  <option
                    v-for="item in list_payments"
                    :value="item.id"
                    :key="item.id"
                  >{{ item.name }}</option>
                </select>
              </div>
            </div>
          </div>
          <!-- <label>{{'Location'|translate}}</label> -->

          <div class="row mb10">
            <div class="col-md-12" v-if="item && active">
              <selectlocation
                :province="item.province_id"
                :district="item.district_id"
                :commune="item.commune_id"
                :p_location="item.location"
                @updateLocation="updateLocation"
              ></selectlocation>
            </div>
            <!-- <div class="col-md-3 col-xs-6 col-sm-6">
              <label>&nbsp;</label>

            </div>-->
          </div>
          <input
            type="submit"
            :disabled="working"
            class="mt10 btn post-button btn-success"
            :value="getButtonText"
          />
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import Utils from '@/helpers/utils'
import Loading from '@/components/elements/Loading'
import selectlocation from '@/components/elements/SelectLocation'
// import GoogleAutocomplete from 'google-autocomplete-vue';
// https://farmbook.com/API/listProvinces
export default {
  title: 'InsertMarket',
  components: {
    Loading,
    selectlocation
  },
  props: ['allProducts', 'user', 'list_payments', 'pass_data', 'types'],
  computed: {
    getButtonText () {
      if (this.item.id) {
        return this.$t('Update')
      } else {
        return this.$t('Add')
      }
    }
  },
  data () {
    let dateFormat = 'DD/MM/YYYY'
    let random = new Date()
    // random to prevent conflict when this element appear on edit and add
    random = random.getTime()
    let data = {
      uploadingPhoto: false,
      active: !!this.pass_data,
      working: false,
      random: random,
      dateFormat: dateFormat,
      editPhotos: this.pass_data ? this.pass_data.images : [],
      item: this.pass_data
        ? JSON.parse(JSON.stringify(this.pass_data))
        : this.defaultValue(),
      list_types: [
        { id: 1, name: this.$t('Buy') },
        { id: 2, name: this.$t('Sell') }
      ]
    }

    return data
  },
  created () {
    // clone from original params
  },
  methods: {
    activeBox (event) {
      if (!this.user) {
        //  return Utils.showLoginZalo();
        this.$router.push({
          name: 'Login'
        })
      }
      let before = this.active
      let now = event.target.className !== 'fas fa-times'
      if (before != now) {
        if (now && !this.user.province_id) {
          this.$alertify.alertWithTitle(
            this.$t('Confirm'),
            this.$t(
              'You need update address in your profile before use this function'
            )
          )
        } else {
          this.active = now
        }
      }
    },
    defaultValue () {
      return {
        product_id: '',
        province_id: this.user && this.user.province_id ? this.user.province_id : '',
        district_id: this.user && this.user.district_id ? this.user.district_id : '',
        commune_id: this.user && this.user.commune_id ? this.user.commune_id : '',
        location: this.user && this.user.location ? this.user.location : null,
        quantity: 0,
        unit_price: 0,
        type_id: 2,
        payment_method: '',
        description: '',
        status: 1
      }
    },
    triggerFile () {
      this.$refs.file.click()
    },
    handleFileUpload () {
      // let file = this.$refs.file.files[0];
      if (this.$refs.file.files.length > 3) {
        return this.$alertify.alertWithTitle(this.$t('Confirm'), this.$t('Tối đa chỉ chọn được 3 ảnh '))
      }
      for (let i = 0; i < this.$refs.file.files.length; i++) {
        this.generalUpload(this.$refs.file.files[i])
      }
    },
    generalUpload (file) {
      if (file.size >= 524288) {
        return this.$alertify.alertWithTitle(
          this.$t('Confirm'),
          this.$t('Exceed maximum upload file size is 500kb')
        )
      }

      var validExtensions = ['jpg', 'png', 'jpeg']
      var reader = new FileReader()

      reader.onloadend = e => {
        this.selectedFile = true
        let arr = new Uint8Array(e.target.result).subarray(0, 4)
        let header = ''
        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16)
        }

        let mimeType = Utils.mimeType(header)
        console.log('mimeType', mimeType)

        if (mimeType === 'unknown') {
          return this.$alertify.alertWithTitle(
            this.$t('Confirm'),
            this.$t('Only these file types are accepted') +
              ' : ' +
              validExtensions.join(', ')
          )
        }

        const blob = new Blob([e.target.result], { type: mimeType})
        this.uploadPhoto(file, blob)
      }
      reader.readAsArrayBuffer(file)
    },
    uploadPhoto (file, blob) {
      this.uploadingPhoto = true
      let formData = new FormData()
      formData.append('file', blob, file.name)

      if (this.item.id) {
        formData.append('market_id', this.item.id)
      }
      let headers = {
        'Content-Type': 'multipart/form-data'
      }
      Utils.request(this, true, 'market')
        .post('/image/', formData, { headers: headers })
        .then(response => {
          this.editPhotos.push(response.data.data)
          this.uploadingPhoto = false
        })
        .catch(() => {
          this.uploadingPhoto = false
          this.$alertify.alertWithTitle(
            this.$t('Confirm'),
            this.$t('There was an issue when request, Please try again')
          )
        })
    },
    removePhoto (photo) {
      this.$alertify.confirmWithTitle(
        this.$t('Confirm'),
        this.$t('Are you sure to remove this photo ?'),
        () => {
          Utils.request(this, true, 'market')
            .delete(`/image/${photo.id}`)
            .then(response => {
              this.editPhotos = this.editPhotos.filter(item => {
                return item.id != photo.id
              })
            })
            .catch(() => {
              this.$alertify.alertWithTitle(
                this.$t('Confirm'),
                this.$t('There was an issue when request, Please try again')
              )
            })
        }
      )
    },
    submitForm () {
      let data = JSON.parse(JSON.stringify(this.item))

      let request
      if (this.item.id) {
        // PUT request does not support validation
        request = Utils.request(this, true, 'market').put(`/manage/`, data)
      } else {
        if (this.editPhotos.length > 0) {
          data.image_ids = this.editPhotos.map(item => {
            return item.id
          })
        }
        request = Utils.request(this, true, 'market').post(`/manage/`, data)
      }
      this.working = true

      request
        .then(response => {
          let data = response.data
          this.working = false
          if (data.status === 'ok') {
            // this.$emit("modalData", {});

            this.$emit('refresh', {})
            if (!this.item.id) {
              this.active = false
              this.item = null
              this.editPhotos = []
              setTimeout(() => {
                this.item = this.defaultValue()
              }, 10)
            }
          } else {
            Utils.showError(this, this.$t(data.data))
          }
        })
        .catch(error => {
          console.log('error', error)
          this.working = false
          Utils.showErrorMessage(this, error.response)
        })
    },
    updateLocation (data) {
      // console.log('data',data)
      for (let key in data) {
        this.item[key] = data[key]
      }
    }
  },
  mounted () {
    // this.item = this.defaultValue();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/InsertMarket.vue